export interface IUserDataNormalizedPublic<IProfile extends IUserProfileBase> {
	id: string;
	updatedAt: any;
	createdAt: any;
	username: string;
	email?: string;
	profile: Partial<IProfile>;
}

export interface IUserDataNormalizedClient<IProfile extends IUserProfileBase> extends IUserDataNormalizedPublic<IProfile> {
	/**@deprecated*/
	_id: string;
	updatedAt: string;
	createdAt: string;
	userCenterLoginToken: string;
}

export type IUserDataNormalizedServer=IUserDataNormalizedClient<IUserProfile>;

export interface IUserListNormalizedClient<IProfile extends IUserProfileBase> extends IUserDataNormalizedPublic<IProfile> {
	updatedAt: string;
	createdAt: string;
}

export interface IUserProfile<IProfileValueType = undefined> extends IUserProfileBase {
	[id: string]: string|number|IProfileValueType;
}

export interface IUserProfileBase {
	description?: string;
	avatar?: string;
	avatarId?: string;
	default_avatar?: string;
	nickname?: string;
}

export interface IUserStoreData<IProfile extends IUserProfileBase = IUserProfile> {
	user: IUserDataNormalizedClient<IProfile>;
	hasLogin: boolean;
	permissions: any;
	debug?: any;
}

export interface IStateUser<IProfile extends IUserProfileBase = IUserProfile> {
	LoginUser: IUserStoreData<IProfile>;
}
